import { useGetQuery } from "@src/appV2/api";
import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib";
import { z } from "zod";

const specialitiesSchema = z.object({
  hasSedationExperience: z.boolean().optional(),
  hasTrayAssemblyExperience: z.boolean().optional(),
  experience: z.array(z.string()).optional(),
  speciality: z.undefined().optional(),
});

const getOpenShiftsDatesRequestQuery = z.object({
  dateFilter: z
    .object({
      start: z.string(),
      end: z.string(),
    })
    .optional(),
  distance: z.union([z.number(), z.string()]).optional(),
  coordinates: z.union([z.array(z.number()), z.array(z.string())]).optional(),
  qualification: z.string().nullish(),
  specialities: specialitiesSchema.optional(),
  tmz: z.string().optional(),
  useAllQualifications: z.boolean().optional(),
});

export const openShiftDate = z.object({
  type: z.literal("open-shift-date"),
  id: z.string(),
  attributes: z.object({
    date: z.string(),
    total: z.number(),
    am: z.number().optional(),
    pm: z.number().optional(),
    noc: z.number().optional(),
  }),
});

export const getOpenShiftsDatesResponse = z.object({
  data: z.array(openShiftDate),
});

export type Specialities = z.infer<typeof specialitiesSchema>;
export type GetOpenShiftDatesRequestQuery = z.infer<typeof getOpenShiftsDatesRequestQuery>;
export type GetOpenShiftDatesResponse = z.infer<typeof getOpenShiftsDatesResponse>;
export type OpenShiftDate = z.infer<typeof openShiftDate>;

export function useGetOpenShiftDates(workerId: string, params: GetOpenShiftDatesRequestQuery) {
  return useGetQuery({
    url: `${environmentConfig.REACT_APP_BASE_API_URL}/workers/${workerId}/open-shift-dates`,

    queryParams: params,
    responseSchema: getOpenShiftsDatesResponse,
    requestSchema: getOpenShiftsDatesRequestQuery,
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.GET_OPEN_SHIFT_DATES_FAILURE,
    },
  });
}
